import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import router from './router'
import VueBarcodeScanner from 'vue-barcode-scanner'
import VScandit from 'vue-scandit';
 
Vue.use(VScandit);


Vue.config.productionTip = false
let options = {
  sound: false, // default is false
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}
Vue.use(VueBarcodeScanner, options)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
